import { stringify as stringifyQs } from "qs";
import urljoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const payoutsSection = "/payouts/";

export const PayoutsListPath = payoutsSection;

export enum PayoutsListUrlFiltersEnum {
  query = "query",
  generatedFrom = "generatedFrom",
  generatedTo = "generatedTo",
  coverageFrom = "coverageFrom",
  coverageTo = "coverageTo",
  payoutStatus = "payoutStatus"
}

export enum PayoutsListUrlFiltersWithMultipleValues {
  brand = "brand",
  mall = "mall"
}

export type PayoutsListUrlDialog = "schedule" | "download" | TabActionDialog;
export type PayoutsListUrlFilters = Filters<PayoutsListUrlFiltersEnum> &
  FiltersWithMultipleValues<PayoutsListUrlFiltersWithMultipleValues>;

export type PayoutsUrlQueryParams = ActiveTab &
  PayoutsListUrlFilters &
  BulkAction &
  Dialog<PayoutsListUrlDialog> &
  Pagination &
  SingleAction;

export const payoutsListUrl = (params?: PayoutsUrlQueryParams) =>
  PayoutsListPath + "?" + stringifyQs(params);

export const payoutDetailsPath = (id: string) => urljoin(payoutsSection + id);

export enum PayoutDetailsUrlFilterEnum {
  query = "query",
  id = "id",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  paymentMethodType = "paymentMethodType",
  settlementDateFrom = "settlementDateFrom",
  settlementDateTo = "settlementDateTo",
  updateTo = "updateTo"
}

export type PayoutDetailsUrlDialog =
  | "download-all"
  | "submit"
  | "settlement"
  | "download"
  | "review"
  | "payable"
  | TabActionDialog;
export type PayoutDetailsUrlFilters = Filters<PayoutDetailsUrlFilterEnum>;
export type PayoutDetailsUrlQueryParams = ActiveTab &
  PayoutDetailsUrlFilters &
  Dialog<PayoutDetailsUrlDialog> &
  Pagination;
export const payoutDetailsUrl = (
  id: string,
  params?: PayoutDetailsUrlQueryParams
) => payoutDetailsPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
